import { TripettoApiObject, TripettoNode } from './tripetto-interfaces';
import { FormlyApiConfig } from '@nx-ahs/formly/shared';

/**
 * Convert Tripetto API object to Formly API props
 */
export function convertApiObject(apiObject: TripettoApiObject): FormlyApiConfig {
	const api: FormlyApiConfig = {
		url: apiObject.url,
		itemFieldLabel: apiObject.itemFieldLabel,
		itemFieldValue: apiObject.itemFieldValue,
		method: apiObject.method || 'Get'
	};

	// Parse options if it's a JSON string
	if (apiObject.options && typeof apiObject.options === 'string') {
		try {
			api.options = JSON.parse(apiObject.options);
		} catch {
			// If parsing fails, leave it as string
			api.options = apiObject.options;
		}
	} else if (apiObject.options) {
		api.options = apiObject.options;
	}

	return api;
}

/**
 * Convert simple conditions to hideExpression
 * Returns undefined for complex conditions (which should be flagged as warnings)
 */
export function convertHideExpression(node: TripettoNode): string | undefined {
	// TODO: Implement simple condition conversion
	// For now, return undefined (complex conditions need manual review)
	return undefined;
}
